/* istanbul ignore file */

// aka initBingTracking
export function initializeBingTracking(bingTrackingCode) {
	(function (w, d, t, r, u) {
		let f, n, i;
		(w[u] = w[u] || []),
			(f = function () {
				const o = { ti: bingTrackingCode, cookieFlags: "SameSite=None;Secure" };
				// eslint-disable-next-line no-undef
				(o.q = w[u]), (w[u] = new UET(o)), w[u].push("pageLoad");
			}),
			(n = d.createElement(t)),
			(n.src = r),
			(n.async = 1),
			(n.onload = n.onreadystatechange =
				function () {
					const s = this.readyState;
					(s && s !== "loaded" && s !== "complete") ||
						(f(), (n.onload = n.onreadystatechange = null));
				}),
			(i = d.getElementsByTagName(t)[0]),
			!i || i.parentNode.insertBefore(n, i);
	})(window, document, "script", "https://bat.bing.com/bat.js", "uetq");

	const sendBingEvent = function () {
		window.uetq.push(...arguments);
	};
	return sendBingEvent.bind(window);
}
